module.exports = __webpack_public_path__ + "media/assets/images/flags/tt-060e4e9dc036e441635841cb4726434a.svg";